import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/design-system.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';

// Tags de SEO que vieram no HTML do pré-render: o React cria as dele ao montar a página, então as antigas saem
// para não ficarem duplicadas (o navegador usaria sempre o primeiro <title>).
document.querySelectorAll('[data-seo]').forEach((el) => el.remove());

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
